export class Folder {
  shapesFolder: '../assets/images/shapes/';
  productLayersFolder: '../assets/images/producLayers/';
  legendFolder;
  languageFolder;
}
